// Set once a GA4 property exists for aiqariskradar.com: analytics.google.com > Admin > Data Streams.
// The gtag.js tag itself is loaded statically in public/index.html (so Google's own
// installation checker can detect it) — this module only toggles whether it's allowed
// to report, for login/logout transitions that happen live within an already-loaded SPA
// session (index.html's inline script only handles the initial-page-load case).
const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

/**
 * Stops GA4 from sending any further hits — the officially documented app-level kill
 * switch (developers.google.com/analytics/devguides/collection/ga4/disable-analytics):
 * every gtag.js call checks window['ga-disable-<MEASUREMENT_ID>'] before sending
 * anything (cookie or hit) to Google's servers. Deliberately not Consent Mode's
 * analytics_storage: 'denied' — that still sends cookieless pings for modeling, which
 * is meant for a cookie-consent-banner UX, not a hard "never track the authenticated
 * dashboard" cutoff like this one. Call this as soon as a user authenticates.
 */
export function stopMarketingAnalytics() {
  if (!MEASUREMENT_ID) return;
  window[`ga-disable-${MEASUREMENT_ID}`] = true;
}

/** Resumes sending hits — call on logout. */
export function resumeMarketingAnalytics() {
  if (!MEASUREMENT_ID) return;
  window[`ga-disable-${MEASUREMENT_ID}`] = false;
}
